import { atom } from "jotai";
import { DMP } from "../types/dmp";

export const dmpAtom = atom<DMP | null>(null);
export const refreshDmpAtom = atom<boolean>(true);
export const contentDmpAtom = atom<any>(true);
export const dmpAuthAtom = atom<any>(null);
export const dmpUrgenceAtom = atom<any>(false);
